export default "__VITE_ASSET__ZlJYrM$z__"